<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <!-- top row / add cluster -->
        <div class="col-12">
          <base-button
            type="success"
            @click.native="modals.registerBasic = true"
            @click="setDefault()"
          >
            <i class="tim-icons icon-simple-add"></i>
            Add Cluster
          </base-button>
        </div>

        <!-- modal to edit -->
        <modal
          :show.sync="modals.edit"
          footer-classes="justify-content-center"
          type="notice"
        >
          <h3 slot="header" class="modal-title">Cluster Info</h3>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <base-input
                  id="clustername"
                  v-model="cluster.clustername"
                  label="Cluster Name"
                  placeholder="Name of the cluster"
                  name="required"
                  type="text"
                ></base-input>
                <base-input
                  label="Electricity Tariff Rate *"
                  placeholder="Electricity tariff"
                  min="0.1"
                >
                </base-input>
                <base-input
                  v-model="cluster.lat"
                  type="text"
                  label="Latitude"
                  placeholder="Latitude"
                ></base-input>
                <base-input
                  v-model="cluster.lon"
                  type="text"
                  label="Longitude"
                  placeholder="Longitude"
                ></base-input>
                <base-input
                  v-model="cluster.tariff"
                  type="text"
                  label="Cluster electricity tariff"
                  placeholder="Cluster electricity tariff"
                ></base-input>
                <base-input
                  v-model="cluster.oldson"
                  type="text"
                  label="SON light deployment rate"
                  placeholder="Old SON light deployment rate"
                ></base-input>

                <base-input
                  id="deviceassoc"
                  label="Device Associate"
                  placeholder="Device associate to the cluster"
                  name="required"
                  type="text"
                  required
                >
                  <el-select
                    multiple
                    class="select-default"
                    size="large"
                    placeholder="Choose..."
                    v-model="deviceID"
                  >
                    <el-option
                      v-for="device in available_dev"
                      :value="device.value"
                      :label="device.label"
                      :key="device.available"
                    ></el-option>
                  </el-select>
                </base-input>
                <!-- <strong>Cluster Name</strong>
                <p v-html="cluster.clustername"></p>-->
              </div>
            </div>
          </div>
          <div slot="footer" class="justify-content-center">
            <base-button type="success" @click.native="handleEdit()"
              >Submit</base-button
            >
          </div>
          <div slot="footer" class="justify-content-center">
            <base-button type="danger" @click.native="modals.edit = false"
              >Close</base-button
            >
          </div>
        </modal>

        <!-- table / content -->
        <br />
        <div class="col-lg-12 col-md">
          <h3 class="card-title brightness">
            <div>
              <div
                class="
                  col-12
                  d-flex
                  justify-content-center justify-content-sm-between
                  flex-wrap
                "
              >
                <el-select
                  class="select-primary mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
                <base-input type="success">
                  <el-input
                    type="search"
                    class="mb-3 search-input"
                    clearable
                    prefix-icon="el-icon-search"
                    placeholder="Search records"
                    v-model="searchQuery"
                    aria-controls="datatables"
                  ></el-input>
                </base-input>
              </div>
              <!-- :header-cell-style="{ background: 'transparent' }" -->
              <el-table
                :data="
                  queriedData.filter(
                    (data) =>
                      !searchQuery ||
                      data.clustername
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase())
                  )
                "
                :header-cell-style="{
                  background: 'transparent',
                  border: 'transparent',
                  'padding-bottom': '0%',
                  'padding-center': '10px',
                  color: 'white',
                }"
                :cell-style="{
                  border: 'transparent',
                  'padding-center': '20px',
                }"
              >
                <!-- <el-table-column label="#" type="index"></el-table-column> -->
                <el-table-column
                  min-width="150"
                  sortable
                  label="Cluster Name"
                  property="clustername"
                ></el-table-column>
                <el-table-column
                  min-width="150"
                  sortable
                  align="right"
                  header-align="right"
                  label="Connection Type"
                  property="conntype"
                ></el-table-column>
                <el-table-column
                  min-width="150"
                  sortable
                  align="right"
                  header-align="right"
                  label="Created At"
                  property="CreatedAt"
                ></el-table-column>
                <el-table-column
                  v-if="hideCol == true"
                  :min-width="135"
                  align="right"
                  label="Actions"
                >
                  <div slot-scope="props">
                    <el-tooltip
                      content="List of device"
                      placement="bottom"
                      effect="light"
                    >
                      <base-button
                        @click.native="modals.getDevices = true"
                        @click="getDeviceAssociates(props.row)"
                        class="edit btn-link"
                        type="success"
                        size="sm"
                        icon
                      >
                        <i class="tim-icons icon-light-3"></i>
                      </base-button>
                    </el-tooltip>
                    <el-tooltip
                      content="Edit"
                      placement="bottom"
                      effect="light"
                    >
                      <base-button
                        @click.native="modals.edit = true"
                        @click="getRow(props.row)"
                        class="edit btn-link"
                        type="success"
                        size="sm"
                        icon
                      >
                        <i class="tim-icons icon-pencil"></i>
                      </base-button>
                    </el-tooltip>
                    <el-tooltip
                      content="Delete"
                      placement="bottom"
                      effect="light"
                    >
                      <base-button
                        @click.native="handleDelete(props.$index, props.row)"
                        @click="getRow(props.row)"
                        class="remove btn-link"
                        type="danger"
                        size="sm"
                        icon
                      >
                        <i class="tim-icons icon-simple-remove"></i>
                      </base-button>
                    </el-tooltip>
                  </div>
                </el-table-column>
              </el-table>
            </div>

            <div
              slot="footer"
              class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            >
              <div>
                <p class="card-category">
                  Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                </p>
              </div>
              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              ></base-pagination>
            </div>
          </h3>
        </div>
      </card>
    </div>
    <modal :show.sync="modals.getDevices" :centered="true" type="large">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        Devices Associates
      </h3>
      <div class="row">
        <div class="col-md-12 table-style">
          <!-- content -->
          <!-- :header-cell-style="{ background: 'transparent' }" -->
          <el-table
            :data="listDevices"
            height="620"
            :header-cell-style="{
              background: 'transparent',
              border: 'transparent',
              'padding-bottom': '0%',
              'padding-center': '10px',
              color: 'white',
            }"
            :cell-style="{
              border: 'transparent',
              'padding-center': '20px',
            }"
          >
            <el-table-column
              v-for="column in deviceColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            ></el-table-column>
            <el-table-column
              :min-width="100"
              align="right"
              label="Unpair Device"
            >
              <div slot-scope="props">
                <base-button
                  @click.native="unpairDevice(props.$index, props.row)"
                  class="remove btn-link"
                  type="danger"
                  size="sm"
                  icon
                >
                  <i class="tim-icons icon-simple-remove"></i>
                </base-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </modal>
    <modal
      :show.sync="modals.registerBasic"
      footer-classes="justify-content-center"
      type="notice"
    >
      <h3 slot="header" class="modal-title">Add Cluster</h3>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <form @submit.prevent>
              <p v-if="errors.length" style="color: red">
                <b>Please correct the following error(s):</b>
              </p>
              <ul>
                <li style="color: red" v-for="error in errors" :key="error">
                  {{ error }}
                </li>
              </ul>
              <div>
                <base-input label="Connection type">
                  <el-select
                    class="select-default"
                    size="large"
                    placeholder="Choose..."
                    v-model="cluster.connType"
                  >
                    <el-option
                      v-for="a in cluster.conn"
                      :value="a.value"
                      :label="a.label"
                      :key="a.value"
                    ></el-option>
                  </el-select>
                </base-input>
                <div v-if="cluster.connType === 'nbiot'">
                  <base-input
                    id="clustername"
                    v-model="cluster.clustername"
                    label="Cluster Name"
                    placeholder="Name of the cluster"
                    name="required"
                    type="text"
                    required
                  ></base-input>
                  <base-input
                    id="multicastid"
                    v-model="cluster.multicastid"
                    label="NB-IoT Multicast Address"
                    placeholder="Multicast address"
                    name="required"
                    type="number"
                    required
                  ></base-input>
                  <base-button
                    class="mt-3"
                    native-type="submit"
                    type="success"
                    @click="closeModal('NEXT')"
                    >Next</base-button
                  >
                  <base-button
                    class="mt-3"
                    type="danger"
                    @click.native="modals.registerBasic = false"
                    >Cancel</base-button
                  >
                </div>
                <div v-else-if="cluster.connType === 'lora'">
                  <base-input
                    id="clustername"
                    v-model="cluster.clustername"
                    label="Cluster Name"
                    placeholder="Name of the cluster"
                    name="required"
                    type="text"
                    required
                  ></base-input>
                  <div style="padding: 5px">
                    <div @click="loraNetworkInfo = true">
                      LoRaWAN Network Key * &nbsp;&nbsp;<i
                        class="fas fa-info-circle"
                      ></i>
                    </div>
                  </div>

                  <base-input
                    id="networkKey"
                    v-model="cluster.networkKey"
                    placeholder="Network Key"
                    name="required"
                    type="text"
                    required
                  >
                  </base-input>

                  <base-alert v-if="loraNetworkInfo" type="success" dismissible>
                    Please enter correct format of LoRaWAN network key.
                    <p style="color: #ffffff">
                      (Ex: 3c432c3a1b1c4e2a24212c444b1c321b)
                    </p>
                  </base-alert>
                  <div style="padding: 5px">
                    <div @click="loraAppInfo = true">
                      LoRaWAN Application Key * &nbsp;&nbsp;<i
                        class="fas fa-info-circle"
                      ></i>
                    </div>
                  </div>
                  <base-input
                    id="appKey"
                    v-model="cluster.appKey"
                    placeholder="Application Key"
                    name="required"
                    type="text"
                    required
                  ></base-input>
                  <base-alert v-if="loraAppInfo" type="success" dismissible>
                    Please enter correct format of LoRaWAN application key.
                    <p style="color: #ffffff">
                      (Ex: 3c432c3a2a24212c444b1c3200000001)
                    </p>
                  </base-alert>
                  <div style="padding: 5px">
                    <div @click="loraMcInfo = true">
                      LoRaWAN Multicast Address * &nbsp;&nbsp;<i
                        class="fas fa-info-circle"
                      ></i>
                    </div>
                  </div>
                  <base-input
                    id="multiAddr"
                    v-model="cluster.multiAddr"
                    placeholder="Multicast Address"
                    name="required"
                    type="text"
                    required
                  ></base-input>
                  <base-alert v-if="loraMcInfo" type="success" dismissible>
                    Please enter correct format of LoRaWAN multicast address.
                    <p style="color: #ffffff">(Ex: 1a2d3b01)</p>
                  </base-alert>
                  <base-button
                    class="mt-3"
                    native-type="submit"
                    type="success"
                    @click="closeModal('NEXT')"
                    >Next</base-button
                  >
                  <base-button
                    class="mt-3"
                    type="danger"
                    @click.native="closeModal('REGISTER')"
                    >Cancel</base-button
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- <p>If you have more questions, don't hesitate to contact us or send us a tweet @creativetim. We're
      here to help!</p>-->
      <div slot="footer" class="justify-content-center">
        <!-- <base-button type="success" @click.native="modals.notice = false">Close</base-button> -->
      </div>
    </modal>

    <modal
      :show.sync="modals.registerAttr"
      footer-classes="justify-content-center"
      type="notice"
    >
      <h3 slot="header" class="modal-title">Add Cluster</h3>
      <base-button class="mt-3 btn-link" @click="closeModal('BACK')">
        <i class="tim-icons icon-minimal-left"></i>Previous
      </base-button>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <form @submit.prevent>
              <p v-if="errors.length" style="color: red">
                <b>Please correct the following error(s):</b>
              </p>
              <ul>
                <li style="color: red" v-for="error in errors" :key="error">
                  {{ error }}
                </li>
              </ul>
              <div>
                <div>
                  <base-input
                    id="clustername"
                    v-model="cluster.tariff"
                    label="Electricity Tariff Rate"
                    placeholder="electricity tariff"
                    name="required"
                    type="text"
                    required
                  ></base-input>

                  <base-input
                    id="networkKey"
                    v-model="cluster.oldson"
                    label="Lights deployment value"
                    placeholder="Old lights watt Value"
                    name="required"
                    type="text"
                    required
                  >
                  </base-input>

                  <base-input
                    id="networkKey"
                    v-model="cluster.lat"
                    label="Cluster Latitude"
                    placeholder="Latitude"
                    name="required"
                    type="text"
                    required
                  >
                  </base-input>

                  <base-input
                    id="networkKey"
                    v-model="cluster.lon"
                    label="Cluster Longitude"
                    placeholder="Longitude"
                    name="required"
                    type="text"
                    required
                  >
                  </base-input>

                  <base-button
                    class="mt-3"
                    native-type="submit"
                    type="success"
                    @click.native="addCluster()"
                    >Add</base-button
                  >
                  <base-button
                    class="mt-3"
                    type="danger"
                    @click.native="closeModal('REGISTER')"
                    >Cancel</base-button
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- <p>If you have more questions, don't hesitate to contact us or send us a tweet @creativetim. We're
      here to help!</p>-->
      <div slot="footer" class="justify-content-center">
        <!-- <base-button type="success" @click.native="modals.notice = false">Close</base-button> -->
      </div>
    </modal>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { Modal, BasePagination, BaseAlert } from "src/components";
import {
  Table,
  TableColumn,
  Select,
  Option,
  DatePicker,
  Alert,
  Tooltip,
} from "element-ui";
import { log } from "util";
import axios from "axios";
import Fuse from "fuse.js";

var moment = require("moment"); // Change date format

export default {
  components: {
    BasePagination,
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseAlert,
    Tooltip,
  },
  data() {
    return {
      deviceColumns: [
        {
          prop: "deviceName",
          label: "Device Name",
        },
        {
          prop: "deviceType",
          label: "Device Type",
        },
        {
          prop: "lat",
          label: "Latitude",
        },
        {
          prop: "lon",
          label: "Longitude",
        },
        // {F
        //   prop: "warranty",
        //   label: "Warranty"
        // },
        {
          prop: "firmwareRev",
          label: "Firmware Revision",
        },
      ],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["Device No", "signal strength"],
      tableColumns: [],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      clusters: [],
      available_dev: [],
      deviceID: "",
      cluster: {
        clustername: "",
        multicastid: "",
        multiAddr: "",
        lat: "",
        lon: "",
        tariff: "",
        oldson: "",
        deviceassoc: "",
        connType: "",
        conn: [
          { label: "NB-IoT", value: "nbiot" },
          { label: "LoRaWAN", value: "lora" },
        ],
        networkKey: "",
        appKey: "",
      },
      errors: [],
      modals: {
        getDevices: false,
        notice: false,
        registerBasic: false,
        registerAttr: false,
        upload: false,
        edit: false,
      },
      roleScope: [],
      hideCol: false,
      getRowData: "",
      listDevices: [],
      loraNetworkInfo: false,
      loraAppInfo: false,
      loraMcInfo: false,
      hover: false,
      info: false,
      updateassoc: false,
      updatebasic: false,
      updateattr: false,
    };
  },

  methods: {
    setDefault() {
      this.cluster.conntype = "";
      this.cluster.clustername = "";
      this.cluster.multicastid = "";
      this.cluster.tariff = "";
      this.cluster.oldson = "";
      this.cluster.lat = "";
      this.cluster.lon = "";
    },
    closeModal(context) {
      if (context == "REGISTER") {
        this.loraNetworkInfo = false;
        this.loraAppInfo = false;
        this.loraMcInfo = false;
        this.modals.registerBasic = false;
        this.modals.registerAttr = false;
      } else if (context == "BACK") {
        this.modals.registerAttr = false;
        this.modals.registerBasic = true;
      } else if (context == "NEXT") {
        this.modals.registerAttr = true;
        this.modals.registerBasic = false;
      }

      this.errors = [];
    },
    getRow(row) {
      this.getRowData = row;
      this.cluster.clustername = `${row.clustername}`;
      this.cluster.lat = `${row.lat}`;
      this.cluster.lon = `${row.lon}`;
      this.cluster.tariff = `${row.tariff}`;
      this.cluster.oldson = `${row.oldson}`;
    },
    validateForm() {
      if (this.cluster.connType === "lora") {
        if (!this.cluster.clustername) {
          this.errors.push("Cluster name is requried");
          return false;
        } else if (!this.cluster.networkKey) {
          this.errors.push("LoRaWAN network key is required");
          return false;
        } else if (!this.cluster.appKey) {
          this.errors.push("LoRaWAN application key is required");
          return false;
        } else if (!this.cluster.multiAddr) {
          this.errors.push("LoRaWAN multicast address is required");
          return false;
        } else if (!this.cluster.tariff) {
          this.errors.push("cluster electricity tariff is required");
          return false;
        } else if (!this.cluster.oldson) {
          this.errors.push("Old SON light is required");
          return false;
        } else if (!this.cluster.lat) {
          this.errors.push("cluster latitude is required");
          return false;
        } else if (!this.cluster.lon) {
          this.errors.push("cluster longitude is required");
          return false;
        }
      } else {
        if (!this.cluster.clustername) {
          this.errors.push("Cluster name is requried");
          return false;
        } else if (!this.cluster.multicastid) {
          this.errors.push("NB-IoT multicast address is required");
          return false;
        } else if (!this.cluster.oldson) {
          this.errors.push("Old SON light is required");
          return false;
        } else if (!this.cluster.tariff) {
          this.errors.push("cluster electricity tariff is required");
          return false;
        } else if (!this.cluster.lat) {
          this.errors.push("cluster latitude is required");
          return false;
        } else if (!this.cluster.lon) {
          this.errors.push("cluster longitude is required");
          return false;
        }
      }

      return true;
    },
    addCluster() {
      // check connection type to create payload
      var payload = null;

      if (this.validateForm()) {
        if (this.cluster.connType === "lora") {
          payload = {
            clustername: this.cluster.clustername,
            conntype: this.cluster.connType,
            appkey: this.cluster.appKey,
            nwkkey: this.cluster.networkKey,
            mcaddr: this.cluster.multiAddr,
            tariff: this.cluster.tariff,
            oldson: this.cluster.oldson,
          };
        } else {
          payload = {
            clustername: this.cluster.clustername,
            multicastid: this.cluster.multicastid,
            conntype: this.cluster.connType,
            tariff: this.cluster.tariff,
            oldson: this.cluster.oldson,
          };
        }

        this.$http
          .post(":8002/api/v1/manage/cluster", payload)
          .then((res) => {
            if (res.error) {
              swal({
                type: "error",
                title: "Oops... Something went wrong!",
                text: res.message,
              });
              //pupout oeror
              // console.log(res.message);
            } else {
              //login OK!
              // console.log(res);
              swal({
                type: "success",
                title: "Successfully Added!",
                text: res.message,
              });
              this.getClusters();
              this.resetForm();
              this.closeModal("REGISTER");
              // target.reset();
              this.cluster.clustername = "";
              this.cluster.multicastid = "";
              this.cluster.connType = "";
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      }
    },
    editClusterBasic() {
      let clusterName = this.cluster.clustername;
      let clusterid = this.getRowData.clusterid;
      let multicastid = this.getRowData.multicastid;
      let clusterType = this.getRowData.conntype;

      let lat = this.cluster.lat;
      let lon = this.cluster.lon;
      let deviceList = this.deviceID;

      let payload = {};
      let payloadattr = {};

      payload = {
        clusterid: clusterid,
        multicastid: multicastid,
        clustername: clusterName,
        lat: parseFloat(lat),
        lon: parseFloat(lon),
        connection_type: clusterType,
      };
      // // console.log(payload);
      this.$http
        .put(
          ":8002/api/v1/manage/cluster/" + this.getRowData.clusterid,
          payload
        )
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
          } else {
            swal({
              title: "Edited!",
              text: `You edited ${this.getRowData.clustername}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
            this.modals.edit = false;
            this.getClusters();
          }
        })
        .catch((err) => {
          // console.log(err);
        });

      // console.log(payload);
    },
    editClusterAttr() {
      let payloadattr = {};
      let tariff = this.cluster.tariff;
      let oldson = this.cluster.oldson;
      payloadattr = {
        data: [
          {
            key: "CLUSTER_TARIFF_RATE",
            value: tariff.toString(),
          },
          {
            key: "CLUSTER_OLD_SON",
            value: oldson.toString(),
          },
        ],
      };

      // console.log(payloadattr);
      this.$http
        .put(
          ":8002/api/v1/manage/cluster/attribute/" + this.getRowData.clusterid,
          payloadattr
        )
        .then((response) => {
          // console.log(response);
          if (response.error) {
            updatebasic = false;
            swal({
              title: "Error!",
              text: response.message,
              type: "error",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          } else {
          }
        });
    },
    // Edit cluster and adding device to cluster
    editCLuster() {
      if (true) {
        // let updateassoc = false;
        // let updateattr = false;
        // let updatebasic = false;

        // console.log(this.getRowData);
        let clusterName = this.cluster.clustername;
        let clusterid = this.getRowData.clusterid;
        let multicastid = this.getRowData.multicastid;
        let clusterType = this.getRowData.conntype;

        let lat = this.cluster.lat;
        let lon = this.cluster.lon;
        let deviceList = this.deviceID;

        let payload = {};
        let payloadattr = {};

        if (deviceList.length > 0) {
          let newArr = [];
          // console.log("AVAI DEVICE: ", this.available_dev);
          //rebuild array attach with device type
          for (let a = 0; a < deviceList.length; a++) {
            for (let i = 0; i < this.available_dev.length; i++) {
              if (deviceList[a] == this.available_dev[i].value) {
                let newObj = {
                  deviceid: deviceList[a],
                  devicetype: this.available_dev[i].devicetype,
                };
                newArr.push(newObj);
              }
            }
          }

          payload = {
            clusterid: clusterid,
            multicastid: multicastid,
            connection_type: clusterType == "LoraWAN" ? "lora" : "nbiot",
            clustername: clusterName,
            lat: parseFloat(lat),
            lon: parseFloat(lon),
            devicelist: newArr,
          };

          this.updateassoc = true;
        } else {
          payload = {
            clusterid: clusterid,
            multicastid: multicastid,
            clustername: clusterName,
            lat: parseFloat(lat),
            lon: parseFloat(lon),
          };
        }

        if (this.updateassoc) {
          // // console.log(payload);
          this.$http
            .post(":8002/api/v1/manage/cluster/device", payload)
            .then((response) => {
              if (response.error) {
                this.updateattr = false;
                this.updatebasic = false;
                swal({
                  title: "Error!",
                  text: response.message,
                  type: "error",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                });
              } else {
                this.editClusterAttr();
                this.editClusterBasic();
              }
            });
        } else {
          this.editClusterAttr();
          this.editClusterBasic();
        }
      } else {
        swal({
          title: "Error!",
          text: "Please select before submitting",
          type: "error",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false,
        });
      }
    },
    handleEdit() {
      swal({
        title: "Are you sure?",
        text: `You want to edit ${this.getRowData.clustername}`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, edit it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.editCLuster();
        }
      });
    },
    // Delete Cluster
    deleteCluster() {
      let urlAPI = ":8002/api/v1/manage/cluster/" + this.getRowData.clusterid;
      this.$http
        .delete(urlAPI)
        .then((res) => {
          console.log("TESTHERE: ", res);

          if (!res.error) {
            swal({
              title: "Deleted!",
              text: `You deleted ${this.getRowData.clustername}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });

            this.getClusters();
          } else {
            swal({
              title: "Opps error",
              text: res.message,
              type: "error",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleDelete(index, row) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteCluster();
        }
      });
    },
    resetForm() {
      // console.log("Reseting the form");

      // Reset our form values
      this.cluster.clustername = null;
      this.cluster.multicastid = null;
      this.errors = [];
      // Trick to reset/clear native browser form validation state
    },
    // Get cluster data to populate in a table
    getClusters() {
      this.clusters = [];
      this.searchedData = [];
      this.$http
        .get(":8002/api/v1/manage/cluster")
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
          } else {
            // console.log(res.message);
            let data = res.message.cluster_list;
            // this.clusters = data;

            //rebuild object
            let arr = [];
            for (let i = 0; i < data.length; i++) {
              let obj = {};
              obj["clustername"] = data[i].cluster_info.clustername;
              obj["clusterid"] = data[i].cluster_info.clusterid;
              obj["lat"] = data[i].cluster_info.lat;
              obj["lon"] = data[i].cluster_info.lon;
              obj["conntype"] =
                data[i].cluster_info.conntype == "lora" ? "LoraWAN" : "NB-IoT";
              obj["multicastid"] = data[i].cluster_info.multicastid;

              data[i].cluster_attribute.map((a) => {
                a.key == "CLUSTER_TARIFF_RATE"
                  ? (obj["tariff"] = parseFloat(a.value))
                  : 0;
              });

              data[i].cluster_attribute.map((a) => {
                a.key === "CLUSTER_OLD_SON"
                  ? (obj["oldson"] = parseFloat(a.value))
                  : 0;
              });

              obj["CreatedAt"] = moment(data[i].cluster_info.createdAt)
                .format("LLL")
                .toString();
              obj["UpdatedAt"] = moment(data[i].cluster_info.createdAt)
                .format("LLL")
                .toString();

              arr.push(obj);
            }

            this.clusters = arr;
            this.searchedData = arr;
            // console.log("FINALDATA: ", this.clusters);
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    // Get all the registered device
    getDevice() {
      this.$http
        .get(":8002/api/v1/manage/device")
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            // console.log(res.message);
          } else {
            //login OK!
            //  // console.log((res.message.users_list[0]))
            let data = JSON.parse(JSON.stringify(res.message.device_list));
            // console.log(data);
            for (let i = 0; i < data.length; i++) {
              let obj = {};
              obj["label"] = data[i].devicename;
              obj["value"] = data[i].deviceid;
              obj["conntype"] = data[i].connection_type;
              obj["devicetype"] = data[i].devicetype;
              this.available_dev.push(obj);
            }
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    getDeviceAssociates(row) {
      // console.log(row);
      // console.log(row.clusterid);
      this.listDevices = [];

      this.$http
        .get(":8002/api/v1/manage/cluster/device/" + row.clusterid)
        .then((res) => {
          if (res.error) {
            // swal({
            //   type: "error",
            //   title: "Oops... Something went wrong!",
            //   text: res.message
            // });
            // console.log(res.message);
          } else {
            let data = JSON.parse(JSON.stringify(res.message.device_list));
            // console.log(data);
            // console.log(data.length);
            for (var i = 0; i < data.length; i++) {
              let listDevice = {
                deviceName: data[i].devicename,
                deviceID: data[i].deviceid,
                deviceType: data[i].devicetype,
                lat: data[i].lat,
                lon: data[i].lon,
                warranty: data[i].warranty,
                firmwareRev: data[i].firmrev,
              };

              this.listDevices.push(listDevice);
            }
            // console.log(this.listDevices);
          }
        })
        .catch((err) => {
          // console.log(err);
        });
      // this.listDevices = [];
    },
    unpairDevice(index, row) {
      // console.log(index);
      // console.log(row);
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.UnpairDeviceRow(row);
          swal({
            title: "Device Unpaired from Cluster!",
            text: `You unpaired ${row.deviceName}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    // unpair the device
    UnpairDeviceRow(row) {
      // console.log(row);
      // console.log(row.deviceID);
      this.$http
        .put(":8002/api/v1/manage/device/unpair/" + row.deviceID, null)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
          } else {
            //login OK!
            // console.log(res);
            swal({
              type: "success",
              text: res.message,
            });

            // panggil device associates
            // console.log(this.listDevices);
            // console.log(row.deviceID);
            // kalau id sama baru splice
            for (var i = 0; i < this.listDevices.length; i++) {
              if (row.deviceID === this.listDevices[i].deviceID) {
                // console.log("id sama");
                this.listDevices.splice(i, 1);
                // console.log(this.listDevices);
              }
            }

            // this.getDeviceAssociates(row)

            // this.getDeviceAssociates(row)
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    // deleteRow(row) {
    //   let indexToDelete = this.tableData.findIndex(
    //     tableRow => tableRow.id === row.id
    //   );
    //   if (indexToDelete >= 0) {
    //     this.tableData.splice(indexToDelete, 1);
    //   }
    // }
  },
  created() {
    // Get token to check for role scope of user
    let jwt_token = JSON.parse(sessionStorage.getItem("accessList"));
    // // console.log(jwt_token)
    // jwt_token = JSON.parse(atob(jwt_token));
    let user_scope = jwt_token;

    for (let i = 0; i < user_scope.length; i++) {
      this.roleScope.push(user_scope[i]);
      for (let j = 0; j < this.roleScope.length; j++) {
        if (this.roleScope[j] === "admin.update") {
          this.hideCol = true;
        }
        if (this.roleScope[j] === "cluster.update") {
          this.hideCol = true;
        }
      }
    }
    // console.log(user_scope);
    this.getClusters();
    this.getDevice();
  },
  computed: {
    queriedData() {
      let result = this.clusters;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.clusters.length;
    },
  },
  mounted() {
    this.fuseSearch = new Fuse(this.clusters, {
      keys: ["clustername", "CreatedAt"],
      threshold: 0.3,
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.clusters;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>

<style lang="scss" scoped>
base-button h4 {
  display: inline;
}
.top base-button h5 {
  display: inline;
}
.table-style {
  background-color: #1d253b;
}
</style>
